export default __webpack_public_path__ + "static/media/right-rotation-code.cd6a2d8f.PNG";